
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'wallet-stroke': {
    width: 19.5,
    height: 16.9,
    viewBox: '0 0 19.5 16.9',
    data: '<path pid="0" d="M16.7 3.5h-2.6v-.7c0-1.5-1.2-2.8-2.8-2.8H8.2C6.7 0 5.5 1.2 5.5 2.8v.8H2.8C1.2 3.5 0 4.7 0 6.3v7.9C0 15.7 1.2 17 2.8 17h14c1.5 0 2.8-1.2 2.8-2.8V6.3c-.1-1.6-1.4-2.8-2.9-2.8zM7 2.8c0-.7.6-1.2 1.2-1.2h3.1c.7 0 1.2.6 1.2 1.2v.5H7v-.5zm11 11.4c0 .7-.6 1.2-1.2 1.2h-14c-.7 0-1.2-.6-1.2-1.2V9.7l8.6 1.3L18 9.7v4.5zm0-6l-7.9 1.3-8.6-1.3V6.3c0-.7.6-1.3 1.3-1.3h14c.6 0 1.2.6 1.2 1.3v1.9z"/>'
  }
})
